import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';

const Navigation = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'nav-glass py-4' : 'bg-transparent py-6'
      }`}
      data-testid="navigation"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between">
        {/* Logo */}
        <div className={`transition-colors duration-300 ${scrolled ? 'text-[#1A1A1A]' : 'text-white'}`}>
          <span className="font-['Playfair_Display'] text-xl md:text-2xl tracking-tight">
            Villa Croissy
          </span>
        </div>

        {/* Right Side */}
        <div className="flex items-center gap-6 md:gap-8">
          {/* Language Toggle */}
          <div 
            className={`flex items-center gap-2 text-sm font-medium cursor-pointer ${
              scrolled ? '' : 'text-white'
            }`}
            data-testid="language-toggle"
          >
            <button
              onClick={toggleLanguage}
              className={`lang-toggle ${language === 'fr' ? 'lang-active' : 'lang-inactive'} ${
                !scrolled && language === 'fr' ? '!text-white' : ''
              } ${!scrolled && language !== 'fr' ? '!text-white/60' : ''}`}
              data-testid="lang-fr-btn"
            >
              FR
            </button>
            <span className={scrolled ? 'text-[#DCDCD9]' : 'text-white/40'}>|</span>
            <button
              onClick={toggleLanguage}
              className={`lang-toggle ${language === 'en' ? 'lang-active' : 'lang-inactive'} ${
                !scrolled && language === 'en' ? '!text-white' : ''
              } ${!scrolled && language !== 'en' ? '!text-white/60' : ''}`}
              data-testid="lang-en-btn"
            >
              EN
            </button>
          </div>

          {/* CTA Button */}
          <button
            onClick={scrollToContact}
            className={`px-5 py-2.5 text-sm font-medium transition-all duration-300 ${
              scrolled
                ? 'btn-primary'
                : 'bg-white/10 backdrop-blur-sm text-white border border-white/30 hover:bg-white hover:text-[#1A2F23]'
            }`}
            data-testid="nav-enquire-btn"
          >
            {t('nav_enquire')}
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navigation;
